export default "__VITE_ASSET__DUwcdpUI__"